;(function() {
"use strict";

angular.module('tmr').filter('time', ['Timestamp', function(timestamp) {
    return function(ts) {
        return timestamp.toString(ts);
    };
}]);
}());
